{
  "name": "wt-angular",
  "version": "0.0.0",
  "scripts": {
    "jest": "jest",
    "jest:coverage": "jest --coverage",
    "ng": "ng",
    "start": "ng serve",
    "startEmulator:external:ios": "export CAPACITOR_BUILD_ENV=development&& sh prepare-ios-resources.sh development && ionic cap run ios --livereload --external --configuration staging-mobile",
    "startEmulator:external:android": "export CAPACITOR_BUILD_ENV=development&& sh prepare-android-resources.sh development && npx jetify && ionic cap run android --livereload --external --configuration staging-mobile",
    "local": "ng serve --configuration=local",
    "localMax": "node --max_old_space_size=6144 ./node_modules/@angular/cli/bin/ng serve --configuration=local",
    "build": "ng build",
    "prebuildCapacitorDev:ios": "export CAPACITOR_BUILD_ENV='development' &&  npm run build && sh prepare-ios-resources.sh development",
    "prebuildCapacitorDev:android": "export CAPACITOR_BUILD_ENV='development' && npm run build && sh prepare-android-resources.sh development  && npx jetify",
    "buildCapacitorDev:ios": "export CAPACITOR_BUILD_ENV='development' && npx cap copy ios && npx cap sync ios && npx cap open ios",
    "buildCapacitorDev:android": "export CAPACITOR_BUILD_ENV='development' && npx cap sync android && npx cap copy android && npx cap open android",
    "prebuild-mobileDev:android": "npm run prebuildCapacitorDev:android",
    "build-mobileDev:android": "export CAPACITOR_BUILD_ENV='development' && ionic capacitor build android --no-open",
    "buildMax": "node --max_old_space_size=6144 ./node_modules/@angular/cli/bin/ng build",
    "buildLocal": "ng build --configuration=local",
    "buildAlpha": "ng build --configuration=alpha",
    "buildStage": "ng build --configuration=staging",
    "buildFeatureEnv": "ng build --configuration=featureEnv",
    "buildFeature2Env": "ng build --configuration=feature2Env",
    "buildFeature3Env": "ng build --configuration=feature3Env",
    "buildFeature4Env": "ng build --configuration=feature4Env",
    "buildFeature4Mobile": "ng build --configuration=feature4-mobile",
    "buildStageMobile": "ng build --configuration=staging-mobile",
    "prebuildCapacitorFeature4:ios": "export CAPACITOR_BUILD_ENV='feature4' && npm run buildFeature4Mobile && sh prepare-ios-resources.sh feature4",
    "prebuildCapacitorFeature4:android": "export CAPACITOR_BUILD_ENV='feature4' && npm run buildFeature4Mobile && sh prepare-android-resources.sh feature4",
    "buildCapacitorFeature4:ios": "export CAPACITOR_BUILD_ENV='feature4' && npx cap copy ios && npx cap sync ios && npx cap open ios",
    "buildCapacitorFeature4:android": "export CAPACITOR_BUILD_ENV='feature4' && npx jetify && npx cap sync android && npx cap copy android && npx cap open android",
    "prebuildCapacitorStage:ios": "export CAPACITOR_BUILD_ENV='stage' && npm run buildStageMobile && sh prepare-ios-resources.sh stage",
    "prebuildCapacitorStage:android": "export CAPACITOR_BUILD_ENV='stage' && npm run buildStageMobile && sh prepare-android-resources.sh stage",
    "buildCapacitorStage:ios": "export CAPACITOR_BUILD_ENV='stage' && npx cap copy ios && npx cap sync ios && npx cap open ios",
    "buildCapacitorStage:android": "export CAPACITOR_BUILD_ENV='stage' && npx jetify && npx cap sync android && npx cap copy android && npx cap open android",
    "buildAlphaMobile": "ng build --configuration=alpha-mobile",
    "prebuildCapacitorAlpha:ios": "export CAPACITOR_BUILD_ENV='alpha' && npm run buildAlphaMobile && sh prepare-ios-resources.sh alpha",
    "prebuildCapacitorAlpha:android": "export CAPACITOR_BUILD_ENV='alpha' && npm run buildAlphaMobile && sh prepare-android-resources.sh alpha",
    "buildCapacitorAlpha:ios": "export CAPACITOR_BUILD_ENV='alpha' && npx cap copy ios && npx cap sync ios && npx cap open ios",
    "buildCapacitorAlpha:android": "export CAPACITOR_BUILD_ENV='alpha' && npx jetify && npx cap sync android && npx cap copy android && npx cap open android",
    "buildPreProdMobile": "ng build --configuration=preprod-mobile",
    "prebuildCapacitorPreProd:ios": "export CAPACITOR_BUILD_ENV='preprodpaas' && npm run buildPreProdMobile && sh prepare-ios-resources.sh preprodpaas",
    "prebuildCapacitorPreProd:android": "export CAPACITOR_BUILD_ENV='preprodpaas' && npm run buildPreProdMobile && sh prepare-android-resources.sh preprodpaas",
    "buildCapacitorPreProd:ios": "export CAPACITOR_BUILD_ENV='preprodpaas' && npx cap copy ios && npx cap sync ios && npx cap open ios",
    "buildCapacitorPreProd:android": "export CAPACITOR_BUILD_ENV='preprodpaas' && npx jetify && npx cap sync android && npx cap copy android && npx cap open android",
    "buildPaasPreProd": "ng build --configuration=preprodpaas",
    "buildPaas": "ng build --configuration=paas",
    "buildPaasStage": "ng build --configuration=stagingPaas",
    "buildPaasAlpha": "ng build --configuration=paasalpha",
    "buildProd": "ng build --configuration=production",
    "buildProdMobile": "ng build --configuration=production-mobile",
    "prebuildCapacitorProd:ios": "export CAPACITOR_BUILD_ENV='production' && npm run buildProdMobile && sh prepare-ios-resources.sh production",
    "prebuildCapacitorProd:android": "export CAPACITOR_BUILD_ENV='production' && npm run buildProdMobile && sh prepare-android-resources.sh production",
    "buildCapacitorProd:ios": "export CAPACITOR_BUILD_ENV='production' && npx cap copy ios && npx cap sync ios && npx cap open ios",
    "buildCapacitorProd:android": "export CAPACITOR_BUILD_ENV='production' && npx jetify && npx cap sync android && npx cap copy android && npx cap open android",
    "buildnfProd": "ng build --configuration=nfProd",
    "buildnfAlpha": "ng build --configuration=nfalpha",
    "buildnfuat": "ng build --configuration=nfuat",
    "buildFifaUat": "ng build --configuration=FifaUat",
    "buildFifaUatMobile": "ng build --configuration=FifaUat-mobile",
    "prebuildCapacitorFifaUat:ios": "export CAPACITOR_BUILD_ENV='fifa_uat' && npm run buildFifaUatMobile && sh prepare-ios-resources.sh fifa_uat",
    "prebuildCapacitorFifaUat:android": "export CAPACITOR_BUILD_ENV='fifa_uat' && npm run buildFifaUatMobile && sh prepare-android-resources.sh fifa_uat",
    "buildCapacitorFifaUat:ios": "export CAPACITOR_BUILD_ENV='fifa_uat' && npx cap copy ios && npx cap sync ios && npx cap open ios",
    "buildCapacitorFifaUat:android": "export CAPACITOR_BUILD_ENV='fifa_uat' && npx jetify && npx cap sync android && npx cap copy android && npx cap open android",
    "buildFifa": "ng build --configuration=Fifa",
    "buildFifaLegacy": "ng build --configuration=FifaLegacy",
    "buildFifaUATLegacy:": "ng build --configuration=FifaUATLegacy",
    "buildFifaProd": "ng build --configuration=FifaProd",
    "buildFifaProdMobile": "ng build --configuration=Fifa-mobile",
    "prebuildCapacitorFifaProd:ios": "export CAPACITOR_BUILD_ENV='fifa_prod' && npm run buildFifaProdMobile && sh prepare-ios-resources.sh fifa_prod",
    "prebuildCapacitorFifaProd:android": "export CAPACITOR_BUILD_ENV='fifa_prod' && npm run buildFifaProdMobile && sh prepare-android-resources.sh fifa_prod",
    "buildCapacitorFifaProd:ios": "export CAPACITOR_BUILD_ENV='fifa_prod' && npx cap copy ios && npx cap sync ios && npx cap open ios",
    "buildCapacitorFifaProd:android": "export CAPACITOR_BUILD_ENV='fifa_prod' && npx jetify && npx cap sync android && npx cap copy android && npx cap open android",
    "buildQatarUat": "ng build --configuration=QatarUat",
    "buildQatarProd": "ng build --configuration=QatarProd",
    "buildNPOUat": "ng build --configuration=NPOUat",
    "buildNPOUatMobile": "ng build --configuration=NPOUat-mobile",
    "prebuildCapacitorNPOUat:ios": "export CAPACITOR_BUILD_ENV='npo_uat' && npm run buildNPOUatMobile && sh prepare-ios-resources.sh npo_uat",
    "prebuildCapacitorNPOUat:android": "export CAPACITOR_BUILD_ENV='npo_uat' && npm run buildNPOUatMobile && sh prepare-android-resources.sh npo_uat",
    "buildCapacitorNPOUat:ios": "export CAPACITOR_BUILD_E V='npo_uat' && npx cap copy ios && npx cap sync ios && npx cap open ios",
    "buildCapacitorNPOUat:android": "export CAPACITOR_BUILD_ENV='npo_uat' && npx jetify && npx cap sync android && npx cap copy android && npx cap open android",
    "buildNPOProd": "ng build --configuration=NPOProd",
    "buildNPOProdMobile": "ng build --configuration=NPOProd-mobile",
    "prebuildCapacitorNPOProd:ios": "export CAPACITOR_BUILD_ENV='npo_prod' && npm run buildNPOProdMobile && sh prepare-ios-resources.sh npo_production",
    "prebuildCapacitorNPOProd:android": "export CAPACITOR_BUILD_ENV='npo_prod' && npm run buildNPOProdMobile && sh prepare-android-resources.sh npo_production",
    "buildCapacitorNPOProd:ios": "export CAPACITOR_BUILD_ENV='npo_prod' && npx cap copy ios && npx cap sync ios && npx cap open ios",
    "buildCapacitorNPOProd:android": "export CAPACITOR_BUILD_ENV='npo_prod' && npx jetify && npx cap sync android && npx cap copy android && npx cap open android",
    "buildCIOProd": "ng build --configuration=CIOProd",
    "buildWDSPRD": "ng build --configuration=WDSPRD",
    "buildWDSUAT": "ng build --configuration=WDSUAT",
    "buildParis2024": "ng build --configuration=paris2024",
    "buildUSUAT": "ng build --configuration=usuat",
    "buildUSPROD": "ng build --configuration=usprod",
    "buildUSSE": "ng build --configuration=usse",
    "buildUSPRODMobile": "node --max_old_space_size=6144 ./node_modules/@angular/cli/bin/ng build --configuration=usprodmobile",
    "prebuildCapacitorUSPROD:ios": "export CAPACITOR_BUILD_ENV='us_prod' && npm run buildUSPRODMobile && sh prepare-ios-resources.sh us_prod",
    "prebuildCapacitorUSPROD:android": "export CAPACITOR_BUILD_ENV='us_prod' && npm run buildUSPRODMobile && sh prepare-android-resources.sh us_prod",
    "buildCapacitorUSPROD:ios": "export CAPACITOR_BUILD_ENV='us_prod' && npx cap copy ios && npx cap sync ios && npx cap open ios",
    "buildCapacitorUSPROD:android": "export CAPACITOR_BUILD_ENV='us_prod' && npx jetify && npx cap sync android && npx cap copy android && npx cap open android",
    "buildAPACUAT": "ng build --configuration=apacuat",
    "buildAPACPROD": "ng build --configuration=apacprod",
    "buildCANUAT": "ng build --configuration=canuat",
    "buildCANPROD": "ng build --configuration=canprod",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "eslint-fix": "npx eslint --ignore-path ./.codestyleignore --fix",
    "eslint-check": "npx eslint --ignore-path ./.codestyleignore",
    "eslint-json": "npx eslint --ignore-path ./.codestyleignore -f json . > eslint_output.json",
    "eslint-ci": "npx eslint --ignore-path ./.codestyleignore --quiet .",
    "eslint-local-compare": "node scripts/eslint-compare-local-with-confluence.js",
    "eslint-update-confluence": "node scripts/eslint_calculate_and_update_confluence.js",
    "format-fix": "npx prettier src/**/*.{ts,html,css,scss} --ignore-path ./.codestyleignore  --write",
    "format-check": "npx prettier src/**/*.{ts,html,css,scss} --ignore-path ./.codestyleignore --check",
    "format-ci": "npx prettier src/**/*.{ts,html,css,scss} --ignore-path ./.codestyleignore --loglevel=warn --check .",
    "serve": "node --max_old_space_size=8048 ./node_modules/@angular/cli/bin/ng serve",
    "prepare": "husky install",
    "translate:generate-map": "node scripts/tr-generate-map.js",
    "translate:populate-default": "node scripts/prepopulate-new-keys-with-defaultText.js",
    "translate:generate-tr-source": "node scripts/translations-export-localazy.js",
    "translate:upload-localazy": "npm run translate:generate-tr-source && npx @localazy/cli upload",
    "translate:download-localazy": "npx @localazy/cli download",
    "prefix-commit-msg": "node scripts/prefix-commit-with-ticket.js",
    "docs:generate": "npx compodoc -p tsconfig.doc.json"
  },
  "private": true,
  "engines": {
    "node": ">=12.20",
    "npm": "^8.15.1"
  },
  "dependencies": {
    "@angular-devkit/build-angular": "21.2.23",
    "@angular-slider/ngx-slider": "21.0.0",
    "@angular/animations": "21.2.19",
    "@angular/cdk": "21.2.5",
    "@angular/common": "21.2.19",
    "@angular/compiler": "21.2.19",
    "@angular/core": "21.2.19",
    "@angular/forms": "21.2.19",
    "@angular/platform-browser": "21.2.19",
    "@angular/platform-browser-dynamic": "21.2.19",
    "@angular/router": "21.2.19",
    "@auth0/angular-jwt": "5.2.0",
    "@awesome-cordova-plugins/core": "8.1.0",
    "@awesome-cordova-plugins/file-opener": "8.1.0",
    "@briebug/jest-schematic": "6.0.0",
    "@capacitor/android": "^8.0.2",
    "@capacitor/angular": "^2.0.3",
    "@capacitor/app": "^8.0.0",
    "@capacitor/browser": "^8.0.0",
    "@capacitor/camera": "^8.0.0",
    "@capacitor/core": "^8.0.0",
    "@capacitor/device": "^8.0.0",
    "@capacitor/filesystem": "^8.0.0",
    "@capacitor/geolocation": "8.1.0",
    "@capacitor/haptics": "^8.0.0",
    "@capacitor/ios": "^8.0.0",
    "@capacitor/keyboard": "^8.0.0",
    "@capacitor/local-notifications": "^8.0.0",
    "@capacitor/network": "^8.0.0",
    "@capacitor/preferences": "^8.0.0",
    "@capacitor/push-notifications": "^8.0.0",
    "@datadog/browser-rum": "^6.26.0",
    "@googlemaps/js-api-loader": "2.0.2",
    "@googlemaps/markerclustererplus": "1.0.1",
    "@googlemaps/markerwithlabel": "2.0.28",
    "@ionic/angular": "8.7.17",
    "@microsoft/signalr": "10.0.0",
    "@ngx-pwa/local-storage": "21.0.0",
    "@ngx-translate/core": "17.0.0",
    "@ngx-translate/http-loader": "17.0.0",
    "@pascalhonegger/ng-datatable": "21.0.0",
    "angular-calendar": "0.32.0",
    "angular-draggable-droppable": "^9.0.1",
    "angular-gridster2": "21.0.1",
    "angular-oauth2-oidc": "20.0.2",
    "angular-oauth2-oidc-jwks": "20.0.0",
    "angular-resizable-element": "^8.0.3",
    "angular-resize-event": "3.2.0",
    "bootstrap": "5.3.8",
    "cordova-plugin-file-opener2": "^4.0.0",
    "core-js": "3.48.0",
    "date-fns": "4.1.0",
    "dhtmlx-gantt": "file:src/assets/Libs/jsLibs/dhxGantt",
    "echarts": "6.1.0",
    "file-saver": "2.0.5",
    "hammerjs": "2.0.8",
    "html2canvas": "1.4.1",
    "moment": "2.30.1",
    "moment-timezone": "0.5.46",
    "ng-mocks": "14.15.0",
    "ng2-cookies": "1.0.12",
    "dragula": "3.7.3",
    "ng2-dragula": "6.0.0",
    "ngx-bootstrap": "20.0.2",
    "ngx-color": "10.1.0",
    "ngx-echarts": "21.0.0",
    "ngx-image-compress": "18.1.5",
    "ngx-image-cropper": "9.1.6",
    "luxon": "3.7.2",
    "ngx-material-timepicker": "13.1.1",
    "ngx-progressbar": "14.0.0",
    "ngx-quicklink": "0.4.9",
    "ngx-quill": "27.1.2",
    "ngx-toastr": "20.0.4",
    "pluralize": "8.0.0",
    "quill": "^2.0.0",
    "quill-mention": "5.0.1",
    "resize-observer-polyfill": "1.5.1",
    "rxjs": "7.8.2",
    "rxjs-compat": "6.6.7",
    "swiper": "^12.1.2",
    "terra-draw": "^1.25.0",
    "terra-draw-google-maps-adapter": "^1.3.1",
    "tslib": "2.8.1",
    "uuid": "14.0.0",
    "valid-url": "1.0.9",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-builders/jest": "21.0.3",
    "@angular-eslint/builder": "21.3.1",
    "@angular-eslint/eslint-plugin": "21.3.1",
    "@angular-eslint/eslint-plugin-template": "21.3.1",
    "@angular-eslint/schematics": "21.3.1",
    "@angular-eslint/template-parser": "21.3.1",
    "@angular/cli": "21.2.19",
    "@angular/compiler-cli": "21.2.19",
    "@angular/language-service": "21.2.19",
    "@capacitor/cli": "^8.0.2",
    "@compodoc/compodoc": "1.2.1",
    "@ionic/angular-toolkit": "12.3.0",
    "@localazy/cli": "2.0.8",
    "@schematics/angular": "21.2.19",
    "@types/echarts": "4.9.22",
    "@types/file-saver": "2.0.7",
    "@types/google.maps": "3.58.1",
    "@types/jasmine": "5.1.7",
    "@types/jasminewd2": "2.0.13",
    "@types/jest": "30.0.0",
    "@types/node": "22.13.10",
    "@types/pluralize": "0.0.33",
    "@types/valid-url": "1.0.7",
    "@typescript-eslint/eslint-plugin": "8.53.0",
    "@typescript-eslint/parser": "8.53.0",
    "axios": "1.18.1",
    "eslint": "9.39.2",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-unused-imports": "4.3.0",
    "glob": "13.0.0",
    "husky": "9.1.7",
    "ie-shim": "^0.1.0",
    "jasmine-core": "6.0.0",
    "jasmine-spec-reporter": "7.0.0",
    "jest": "30.2.0",
    "jetifier": "2.0.0",
    "lint-staged": "16.2.7",
    "prettier": "3.8.0",
    "react": "19.2.3",
    "react-dom": "19.2.3",
    "ts-node": "10.9.2",
    "typescript": "5.9.3"
  },
  "lint-staged": {
    "*.{ts,html,scss}": "npm run format-fix --"
  },
  "optionalDependencies": {
    "@lmdb/lmdb-linux-x64": "3.0.13",
    "@rollup/rollup-darwin-arm64": "4.60.1",
    "@rollup/rollup-darwin-x64": "4.60.1",
    "@rollup/rollup-linux-x64-gnu": "4.60.1"
  },
  "overrides": {
    "ws": "^8.20.1",
    "rollup": "4.60.1",
    "body-parser": "1.20.6",
    "send": "0.19.0",
    "serve-static": "1.16.2",
    "express": "4.21.1",
    "micromatch": "4.0.8",
    "webpack": "5.104.1",
    "http-proxy-middleware": "2.0.10",
    "markdown-to-jsx": "7.4.0",
    "cross-spawn": "7.0.5",
    "path-to-regexp": "8.4.2",
    "nanoid": "^3.3.18",
    "esbuild": "0.28.1",
    "@babel/runtime": "7.26.10",
    "@babel/helpers": "7.26.10",
    "prismjs": "1.30.0",
    "brace-expansion": "2.1.4",
    "form-data": "4.0.6",
    "on-headers": "1.1.0",
    "@eslint/plugin-kit": "0.3.4",
    "tmp": "0.2.7",
    "js-yaml": "4.3.2",
    "diff": ">=8.0.3",
    "chokidar": "^5.0.0",
    "readdirp": "^5.0.0",
    "qs": "6.16.0",
    "@babel/core": "7.29.7",
    "@isaacs/brace-expansion": "5.0.1",
    "@modelcontextprotocol/sdk": "1.26.0",
    "lodash-es": "4.18.1",
    "lodash": "4.18.1",
    "handlebars": "^4.7.9",
    "hono": "4.12.34",
    "@hono/node-server": "2.1.0",
    "yaml": "2.8.3",
    "flatted": "3.4.2",
    "tar": "7.5.22",
    "serialize-javascript": "7.0.5",
    "undici": "8.10.0",
    "picomatch": "4.0.4",
    "express-rate-limit": "8.3.2",
    "@xmldom/xmldom": "0.9.12",
    "vite": "7.3.6",
    "piscina": "5.2.0",
    "ajv": "8.18.0",
    "follow-redirects": "1.16.0",
    "axios": "1.18.1",
    "fast-uri": "3.1.7",
    "@babel/plugin-transform-modules-systemjs": "7.29.4",
    "uuid": "14.0.0",
    "ip-address": "^10.4.0",
    "webpack-dev-server": "5.2.6",
    "postcss": "^8.5.23",
    "browserslist": "^4.28.8"
  }
}
